import React from 'react';
import PropTypes from 'prop-types';
import PriceLabel from '@prisjakt/ui-price-label';
import Currency from '@prisjakt/ui-currency';

const InternationalPriceLabel = props => {
  const { currency, value, toneDown } = props;
  if (!currency || !value) {
    return null;
  }

  return (
    <PriceLabel
      bold={false}
      value={<Currency code={currency} price={value} />}
      styling={toneDown ? 'lighten' : 'secondary'}
    />
  );
};

const { string, bool } = PropTypes;
InternationalPriceLabel.propTypes = {
  currency: string.isRequired,
  value: string.isRequired,
  toneDown: bool,
};

InternationalPriceLabel.defaultProps = {
  toneDown: false,
};

export default InternationalPriceLabel;
